import * as React from 'react';

import Agenda from '../widgets/Agenda';
import Reviews from '../widgets/Reviews';
import Amenities from './Amenities';
import Layout from '../Layout';

export default class BedroomSuite extends React.Component<{}, {}> {

    render() {
        return (
            <Layout id="bedroom-suite"
                    title="Bedroom Suite - Gulf Front"
                    subtitle="Feel the breeze of the ocean as you relax and enjoy the view"
                    background="/images/bedroom_suite/drinks.jpg">

              <Agenda />

              <div className="amenities section">
                <div className="row">
                  <div className="seven wide column">
                    <img src="/images/bedroom_suite/livingroom.jpg" />
                  </div>
                  <div className="five wide desc widget column">
                    <h2>
                      We offer<br />
                      many amenities
                    </h2>
                    <p>
                      We offer modern and nicely decorated rooms, and
                      several unique amenities to accommodate you.
                    </p>
                    <Amenities typename="Bedroom Suite" folding={ true } />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="eight wide four off column">
                  <img src="/images/bedroom_suite/fruits.jpg" />
                </div>
              </div>

              <div className="row">
                <div className="seven wide column">
                  <img src="/images/bedroom_suite/bedroom.jpg" />
                </div>
                <div className="four wide column" style={ { marginTop: '244px' } }>
                  <img src="/images/bedroom_suite/juice.jpg" />
                </div>
              </div>

              <div className="row">
                <div className="three wide two off column">
                  <img src="/images/bedroom_suite/kitchen.jpg" />
                </div>
                <div className="seven wide column">
                  <img src="/images/bedroom_suite/bathroom.jpg" />
                </div>
              </div>

              <div className="row">
                <div className="nine wide two off column">
                  <img src="/images/bedroom_suite/white-sand-beach.jpg" />
                </div>
              </div>

              <Reviews />

            </Layout>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/rooms/BedroomSuite.tsx
 **/